'use es6'; // Focus/open the widget properties editor.

export const FOCUS_WIDGET_PROPERTIES_EDITOR = 'FOCUS_WIDGET_PROPERTIES_EDITOR';
export const SCROLL_ACTIVE_TAB_INTO_VIEW = 'SCROLL_ACTIVE_TAB_INTO_VIEW';
export const FOCUS_FINDER_SEARCH = 'FOCUS_FINDER_SEARCH';
export const OPEN_STATUS_BAR_DRAWER = 'OPEN_STATUS_BAR_DRAWER'; // Set cursor in IDECodeMirror given a sessionId

export const SET_CURSOR_IN_IDE_CODE_MIRROR = 'SET_CURSOR_IN_IDE_CODE_MIRROR';
export const CODEMIRROR_SESSION_REDO = 'CODEMIRROR_SESSION_REDO';
export const CODEMIRROR_SESSION_UNDO = 'CODEMIRROR_SESSION_UNDO';
/* Reset language editor after regenerating translations */

export const LANGUAGE_EDITOR_LANGUAGE_REGENERATED = 'LANGUAGE_EDITOR_LANGUAGE_REGENERATED';